import { OdataItems } from '@/shared/model/OdataItems';
import { SearchParams } from '@/shared/model/searchParams';
import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import AdmpNewsDocumentDialog from './admp-news-document-dialog/admp-news-document-dialog.vue';
import { CONST } from '@/shared/utils/Constants';
import { ROUTES } from '@/router/routesEnum';
import D4yTableMini from '@/components/d4y-table-mini/d4y-table-mini.vue';

import GeneralUtils from '@/shared/utils/generalUtils';

const name = 'admpNewsDocument-view';
const admpNewsModule = namespace('admpNews');
const authModule = namespace('auth');

@Component({ name: name, components: { AdmpNewsDocumentDialog, D4yTableMini } })
export default class AdmpNewsDocumentsComponent extends Vue {
  @authModule.Getter('isUserInAzureAdminGroup')
  private isUserInAzureAdminGroup!: any;
  @authModule.Getter('isUserSupportOrSuperAdmin')
  private isUserSupportOrSuperAdmin!: any;
  @authModule.Getter('isUserSupport')
  private isUserSupport!: any;
  @authModule.Getter('isUserGsUser')
  private isUserGsUser!: any;
  @authModule.Getter('isUserOnlyGs')
  private isUserOnlyGs!: any;
  @authModule.Getter('contactFullName')
  private contactFullName!: any;
  @admpNewsModule.Action('deleteAdmpNewsFile')
  private actionDeleteAdmpNewsFile!: any;
  @admpNewsModule.Action('getNewsFileDownloadLink')
  private actionGetNewsFileDownloadLink!: any;

  @Ref('observer-add-edit-admpNews-form') private observerForm!: any;

  @Prop({ default: () => [] })
  private files!: any;
  @Prop({ default: () => {} })
  private admpNews!: any;

  @Prop({ default: false })
  private disabled!: boolean;

  @Prop({ default: CONST.emptyGuid })
  private locationId!: string;
  @Prop({ default: '' })
  private admpNewsCreatedId!: string;

  @Ref('admpNewsDocument-add-edit-ref')
  private admpNewsDocumentAddEditRef!: AdmpNewsDocumentDialog;

  admpNewsDocumentsIsLoading = true;
  admpNewsDocumentsSearchParams = {};
  selectedFile: any;
  public showSuccessSnackbar: boolean = false;
  public snackbarTitle: string = '';
  public snackbarMessage: string = '';
  public isDeleteDocument: boolean = false;
  public isDeleteDocumentDialogOpen: boolean = false;

  get admpNewsFilesDocsCount() {
    return this.admpNews.news_files.filter((x: any) => x.bucket_name == 'admpnl-news-anlagen').length;
  }

  get admpNewsId() {
    return this.$route.params['admpNewsId'];
  }

  get isNewsCreate() {
    return this.admpNewsId == '0' || !this.admpNewsId;
  }

  get admpNewsFiles() {
    return this.files;
  }

  get admpNewsDocumentsTotal() {
    return this.files?.length || 0;
  }

  created() {
    setTimeout(() => {
      this.admpNewsDocumentsIsLoading = false;
    }, 1000);
  }

  private image = {
    src: '', //'cv_document.svg',
    header: '',
    height: 0, //85,
    width: 140,
  };

  async download(item: any) {
    console.log('item :>> ', item);
    let attachmentPayload = {
      FileName: item.filename,
      BucketName: item.bucket_name,
      DisplayName: item.display_name,
      OriginalName: item.original_name,
      IsSaveOnDisk: true,
    };
    await this.actionGetNewsFileDownloadLink(attachmentPayload).then((res: any) => {
      // console.log('actionGetNewsFileDownloadLink attachmentFile res :>> ', res);
    });
  }

  get headers() {
    let headers: {
      text: string | any;
      value: string;
      sortable?: boolean;
      width?: string;
      align?: string;
    }[] = [
      { text: this.$t('name'), value: 'display_name' },
      { text: this.$t('filename'), value: 'original_name' },
      {
        text: this.$t('actions'),
        value: 'actions',
        sortable: false,
        width: '1%',
        align: 'center',
      },
    ];
    return headers;
  }

  private async admpNewsDocumentsUpdateOptions(newVal: any, oldVal: any) {}

  //#region AddEdit admpNewsDocument
  admpNewsDocumentDialog = {
    show: false,
    showDelete: false,
    model: { ...this.admpNews },
  };

  onAdd() {
    this.$emit('request:add-document');
    if (this.admpNews.id != 0) {
      this.add();
    }
  }

  public openAddDialog() {
    this.admpNewsDocumentDialog.model = { ...this.admpNews };
    this.admpNewsDocumentDialog.show = true;
  }

  add() {
    this.openAddDialog();
  }

  async admpNewsDocumentDialogOnClose(data: any) {
    this.admpNewsDocumentDialog.model = { ...this.admpNews };
    this.admpNewsDocumentDialog.show = false;
  }

  editAdmpNewsDocument(editAdmpNewsDocument: any) {
    this.admpNewsDocumentDialog.model = { ...editAdmpNewsDocument };
    this.admpNewsDocumentDialog.show = true;
  }

  async admpNewsDocumentDialogOnUpdate(admpNewsDocument: any, zrDocumentRef: any, fileName: string) {
    this.admpNewsDocumentDialog.show = false;
    if (!admpNewsDocument) return;

    let ind = this.admpNews.news_files.findIndex((x: any) => x.id == admpNewsDocument.id);
    if (ind > -1) {
      this.admpNews.news_files.splice(ind, 1, admpNewsDocument);
      this.snackbarTitle = this.$te('success') ? (this.$t('success') as string) : 'Erfolgreich gespeichert';
      this.snackbarMessage = this.$te('success_uploaded')
        ? (this.$t('success_uploaded') as string)
        : 'Dokument erfolgreich hinzugefügt';
      this.showSuccessSnackbar = true;
    } else {
      this.snackbarTitle = this.$te('success') ? (this.$t('success') as string) : 'Erfolgreich gespeichert';
      this.snackbarMessage = this.$te('success_added')
        ? (this.$t('success_added') as string)
        : 'Dokument erfolgreich hinzugefügt';
      this.showSuccessSnackbar = true;
      this.admpNews.news_files = [...this.admpNews.news_files, admpNewsDocument];
    }

    this.$emit('document:uploaded', admpNewsDocument);
  }

  public deleteImage(item: any) {
    this.selectedFile = item;
    this.isDeleteDocumentDialogOpen = true;
  }

  async deleteAdmpNewsDocument() {
    console.log('item :>> ', this.selectedFile);
    if (!this.selectedFile) return;
    let payload = {
      FileName: this.selectedFile.filename,
      BucketName: this.selectedFile.bucket_name,
      admpNewsFileId: this.selectedFile.id,
    };
    try {
      await this.actionDeleteAdmpNewsFile(payload).then((response: any) => {
        // console.log('response AFTER delete:>> ', response);
        this.showSuccessSnackbar = true;
        this.snackbarTitle = this.$te('title_deleted')
          ? (this.$t('title_deleted') as string)
          : 'Erfolgreich gespeichert';
        this.snackbarMessage = this.$te('success_deleted')
          ? (this.$t('success_deleted') as string)
          : 'Erfolgreich gelöscht';
        if (response.isValid && response.result) {
          let index = this.admpNews.news_files.findIndex((x: any) => x.id == response.result.id);
          if (index > -1) {
            this.admpNews.news_files.splice(index, 1);
          }
        }
      });
    } catch (error) {
      console.error('Failed to delete AdmpNews document:', error);
    } finally {
      this.isDeleteDocumentDialogOpen = false;
      this.selectedFile = null;
    }
  }

  //#endregion
}
